import { MutableRefObject, useCallback, useRef, useState } from "react";

export function useReferencedState<T>(
    initialState: T,
): [MutableRefObject<T>, (value: T) => void, () => boolean] {
    const [value, _setValue] = useState(initialState);
    const referencedValue = useRef(value);
    const setValue = useCallback((value: T) => {
        referencedValue.current = value;
        _setValue(typeof value === "function" ? () => value : value);
    }, []);

    const isEmpty = useCallback((): boolean => {
        const currentValue = referencedValue.current;
        return !currentValue || Object.keys(currentValue).length === 0;
    }, []);

    return [referencedValue, setValue, isEmpty];
}
